<!-- @format -->

<ng-container *transloco="let t">
  @if (courseUnit && product) {
    <fudis-expandable
      [level]="2"
      [title]="(courseUnit.name | localizedString) + ' (' + ({ min: product.credits, max: product.credits } | creditRange) + ')'"
      [subTitle]="courseUnit.code"
      [attr.data-cy]="'cu-code-enrolledItem'">
      <ng-template fudisExpandableContent>
        <fudis-grid [rowGap]="'md'" [width]="'initial'">
          <fudis-grid [columns]="{ md: '1fr 2fr' }" [rowGap]="'md'" [width]="'initial'">
            <fudis-dl [variant]="'compact'">
              <fudis-dl-item>
                <fudis-dt [contentText]="t('OPEN_UNIVERSITY.STUDY_OFFERING.SALES_PERIOD')" />
                <fudis-dd [contentText]="product.salesPeriod | localDateTimeRange" />
              </fudis-dl-item>
              <fudis-dl-item>
                <fudis-dt [contentText]="t('OPEN_UNIVERSITY.STUDY_OFFERING.ENROLMENT_RIGHT_VALIDITY')" />
                <fudis-dd [contentText]="product.validityPeriod | localDateRange" />
              </fudis-dl-item>
              <fudis-dl-item>
                <fudis-dt [contentText]="t('OPEN_UNIVERSITY.STUDY_OFFERING.CREDITS_LABEL')" />
                <fudis-dd [contentText]="(product.credits | decimalNumber) + ' ' + t('OPEN_UNIVERSITY.STUDY_OFFERING.CREDITS_LONG')" />
              </fudis-dl-item>
              <fudis-dl-item>
                <fudis-dt [contentText]="t('OPEN_UNIVERSITY.STUDY_OFFERING.PRICE')" />
                <fudis-dd
                  data-cy="study-voucher-price"
                  [contentText]="t('OPEN_UNIVERSITY.STUDY_VOUCHER_CONFIRMATION_COMPLETED.PRICE_VALUE')" />
              </fudis-dl-item>
            </fudis-dl>
            <fudis-dl [variant]="'regular'" [columns]="1">
              @if (product.description; as description) {
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('OPEN_UNIVERSITY.STUDY_OFFERING.PRODUCT_DESCRIPTION')" />
                  <fudis-dd><sis-localized-markup-string-view [content]="description" /></fudis-dd>
                </fudis-dl-item>
              }
              @if (completionMethod?.prerequisites | localizedString; as prerequisites) {
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('FIELD_NAMES.prerequisites')" />
                  <fudis-dd [contentText]="prerequisites" />
                </fudis-dl-item>
              }
              @if (completionMethod?.evaluationCriteria | localizedString; as evaluationCriteria) {
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('FIELD_NAMES.grading')" />
                  <fudis-dd [contentText]="evaluationCriteria" />
                </fudis-dl-item>
              }
            </fudis-dl>
          </fudis-grid>
          @if (openUniStudentEnrolments$ | async; as openUniStudentEnrolments) {
            <app-open-university-enrolled-info
              [assessmentItemsData]="assessmentItemsData"
              [openUniStudentEnrolments]="openUniStudentEnrolments" />
          }
        </fudis-grid>
      </ng-template>
    </fudis-expandable>
  }
</ng-container>
